function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-selector");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-selector",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(14.500000, 15.000000) rotate(-30.000000) translate(-14.500000, -15.000000) translate(8.000000, 2.500000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Polygon",
  points: "6.5 -3.55717736e-13 13 18.2780528 6.51849305 15 6.48150695 15 3.69482223e-13 18.2780528"
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.5,
  y1: 15.5,
  x2: 6.5,
  y2: 24.5,
  id: "Line"
}))));

const SvgIco30Selector = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Selector, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-selector.d595f552.svg";
export { ForwardRef as ReactComponent };